function linearGradient(color: string, colorState: string, angle = 195) {
  return `linear-gradient(${angle}deg, ${color}, ${colorState})`;
}
export function linearGradient3scale(color: string, colorState: string) {
  return `linear-gradient(to right, ${color}, ${colorState}, ${color})`;
}

export default linearGradient;
